// extracted by mini-css-extract-plugin
export default {"root":"root___n2DMC","icon":"icon___VPc65","notificationText":"notificationText___NOA9E","link":"link___wgux5"};